import { TypographyOptions } from '@mui/material/styles/createTypography';
import { COLORS } from '@/config/colors';

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }: { sm: number; md: number; lg: number }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm)
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md)
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg)
    }
  };
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    fontSecondaryFamily: React.CSSProperties['fontFamily'];
    fontWeightSemiBold: React.CSSProperties['fontWeight'];
  }
}

export const TYPOGRAPHY: TypographyOptions = {
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  fontFamily: 'Lexend, system-ui, sans-serif',
  allVariants: {
    color: COLORS.grey[50]
  },
  h1: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(16)
  },
  h2: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(14)
  },
  h3: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(12)
  },
  h4: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(12)
  },
  h5: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(12)
  },
  h6: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(12)
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(13)
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(12)
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(13)
  },
  body2: {
    lineHeight: 1.5,
    fontSize: pxToRem(12)
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(11)
  },
  overline: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(11),
    letterSpacing: '0.04em',
    textTransform: 'uppercase'
  },
  button: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
    textTransform: 'unset'
  }
} as const;
